// extracted by mini-css-extract-plugin
export default {"tip":"Faq_tip__-lEtT","tip__name":"Faq_tip__name__6vUtm","tip__image":"Faq_tip__image__Mua0j","tip__text":"Faq_tip__text__+AbQi","bulletList":"Faq_bulletList__Cx3gy"};